import { FC } from 'react';
import { ComponentRendering, Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';
import { isEmpty } from 'lodash';

import { mapSharedPropertiesToFields } from 'common/getters';
import { usePathMatch } from 'composables/shared/usePathMatch';
import { ComponentProps } from 'lib/component-props';

type TopWarningMessageRendering = {
  fields: TopWarningMessageFields;
};
type TopWarningMessageFields = {
  message?: Field<string>;
  whitelistPaths?: Field<string>;
  isActive?: Field<boolean>;
};
type TopWarningMessageProps = {
  rendering: TopWarningMessageRendering & ComponentRendering;
  showWarning: boolean;
} & ComponentProps;

export const TopWarningMessage: FC<TopWarningMessageProps> = ({ rendering }) => {
  const { isCurrentPathMatched } = usePathMatch();
  const data = mapSharedPropertiesToFields<TopWarningMessageFields>(rendering.fields);

  const isOnWhiteList = isCurrentPathMatched(data.whitelistPaths?.value);
  const showWarning = isOnWhiteList && data?.isActive?.value;

  if (!showWarning) return null;

  const hasMessage = data.message && !isEmpty(data.message.value);
  if (!hasMessage) return null;
  const cleanHTMLMessage = sanitize(data.message?.value ?? '');
  return (
    <div className="bg-yellow">
      <div
        className="container px-0 py-1 text-center"
        dangerouslySetInnerHTML={{ __html: cleanHTMLMessage }}
      />
    </div>
  );
};

export default withDatasourceCheck()<TopWarningMessageProps>(TopWarningMessage);
